import React from 'react';
import PropTypes from 'prop-types';

import { CDN_URL } from '../../constants';

const AuthorHero = ({ image, first_name: firstName, last_name: lastName, ...rest }) => {
  const name = [firstName, lastName].filter((e) => !!e).join(' ');

  if (!name || !image) {
    return null;
  }

  return (
    <div className='author-hero' {...rest}>
      {image && (
        <div
          className='author-hero__image'
          style={{ backgroundImage: `url(${CDN_URL}${image})` }}
        />
      )}
      <div className='author-hero__container'>
        {name && <div className='author-hero__title'>{name}</div>}
        <div className='author-hero__subtitle'>Questions & Answers</div>
      </div>
    </div>
  );
};

AuthorHero.propTypes = {
  image: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
};

export default AuthorHero;
